import "./Card.css";
import ad from "./ad.png";

function Card() {
    return (
      <div className="Activitiescardcss">
        <img className="ActImage" src={ad} alt={""}></img>
      </div>
    );
  }
  
export default Card;